module.exports = __webpack_public_path__ + "img/google-icon.fb7e98b5.svg";